import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";

const ReasonModal = ({ t, showModal, title, loading, setReason, handleModalClose, handleOk }) => (
    <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="text-primary mb-2">{t("sideNav.rejectJobRequest.reason")}</p>
                            <textarea onChange={e => setReason(e.target.value)} className="w-100 p-2" rows="8" placeholder="Enter the reason for job rejection" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleOk}>
                                {t("sideNav.rejectJobRequest.reject")} {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
);

export default ReasonModal;